type Language = 'en' | 'eu';

const EN: Record<string, string> = {
  Deformaciones: 'Deformations',
  Roturas: 'Breakages',
  Exudaciones: 'Bleeding',
  'Deformaciones. Roderas': 'Deformations. Rutting',
  'Deformaciones. Hundimiento': 'Deformations. Depression',
  'Deformaciones. Cordón longitudinal': 'Deformations. Longitudinal ridge',
  'Deformaciones. Arrollamiento transversal': 'Deformations. Transverse shoving',
  'Deformaciones. Firme ondulado': 'Deformations. Corrugated pavement',
  'Deformaciones. Ondulación': 'Deformations. Undulation',
  'Deformaciones. Blandón': 'Deformations. Soft spot',
  'Deformaciones. Huella': 'Deformations. Wheel track',
  'Deformaciones. Burbuja': 'Deformations. Blister',
  'Deformaciones. Protuberancia': 'Deformations. Bulge',
  'Deformaciones. Escalonamientos': 'Deformations. Faulting',
  'Deformaciones. Asientos': 'Deformations. Settlement',
  'Roturas. Grieta longitudinal': 'Breakages. Longitudinal crack',
  'Roturas. Bache': 'Breakages. Pothole',
  'Roturas. Grieta transversal': 'Breakages. Transverse crack',
  'Roturas. Grieta errática': 'Breakages. Irregular crack',
  'Roturas. Grieta parabólica': 'Breakages. Parabolic crack',
  'Roturas. Cuarteo en malla': 'Breakages. Alligator cracking',
  'Roturas. Grietas en las rodadas': 'Breakages. Wheel-path cracks',
  'Roturas. Grieta en el borde': 'Breakages. Edge crack',
  'Roturas. Grieta reflejada': 'Breakages. Reflection crack',
  'Roturas. Grieta curva': 'Breakages. Curved crack',
  'Roturas. Fisuras finas': 'Breakages. Fine cracking',
  'Roturas. Descascarillado': 'Breakages. Spalling',
  'Exudaciones. Flujo de ligante': 'Bleeding. Binder flow',
  'Exudaciones. Ascensión de finos': 'Bleeding. Fines pumping',
  Fluencias: 'Creep',
  Desgaste: 'Wear',
  Desplazamiento: 'Displacement',
  Desalineación: 'Misalignment',
  'Falta de reflectancia': 'Lack of reflectivity',
  'Fallo eléctrico': 'Electrical failure',
  'Pantalla dañada': 'Damaged display',
  'Información incorrecta': 'Incorrect information',
  Rotura: 'Breakage',
  Suciedad: 'Dirt',
  Desprendimiento: 'Detachment',
  'Deformación por impacto': 'Impact deformation',
  Erosión: 'Erosion',
  Colapso: 'Collapse',
  'Rejilla rota': 'Broken grate',
  Sedimentación: 'Sedimentation',
  'Tapa rota': 'Broken cover',
  'Infiltraciones/mancha humedad': 'Leakage/damp patch',
  'Colapso estructural': 'Structural collapse',
  Inundación: 'Flooding',
  Inestabilidad: 'Instability',
  Asentamientos: 'Settlements',
  Deslizamientos: 'Landslides',
  'Rotura de malla': 'Mesh breakage',
  'Escollera desplazada': 'Displaced riprap',
  'Fallo de anclajes': 'Anchor failure',
  Corrosión: 'Corrosion',
  Vegetación: 'Vegetation',
  Residuos: 'Waste',
  Oxidación: 'Oxidation',
  'Lámpara rota': 'Broken lamp',
  'Puerta rota': 'Broken door',
  'Fallo de sensores': 'Sensor failure',
  Desconfiguración: 'Misconfiguration',
  'iluminación insuficiente': 'Insufficient lighting',
  'Fallo de juntas': 'Joint failure',
  'Falta de estanqueidad': 'Loss of watertightness',
  'Fallo de ventiladores': 'Fan failure',
  'Fallo de señalización': 'Signage failure',
  'Fallo de Comunicación': 'Communication failure',
  'Fallo mecánico': 'Mechanical failure',
  'Fallo estructural': 'Structural failure',
  '1 CALZADA': '1 ROADWAY',
  '6 APARTADEROS': '6 PULL-OFF AREAS',
  '9 TÚNELES': '9 TUNNELS',
  '10 VIAS DE SERVICIO': '10 SERVICE ROADS',
  '2 SEÑALIZACIÓN': '2 SIGNAGE',
  '3 BALIZAMIENTO': '3 DELINEATION',
  '5 TALUDES': '5 SLOPES',
  '11 ELEMENTOS DE SEGURIDAD': '11 SAFETY ELEMENTS',
  '1.1 CARRIL': '1.1 LANE',
  '1.2 ARCÉN': '1.2 SHOULDER',
  '1.3 BERMA': '1.3 VERGE',
  '6.1 Zona de parada de emergencia': '6.1 Emergency stopping area',
  '6.2 Zona de inspección de vehículos': '6.2 Vehicle inspection area',
  '6.3 Zona de conservación': '6.3 Maintenance area',
  'Calzada interior': 'Interior roadway',
  '10.1 Calzada': '10.1 Roadway',
  '2.1 HORIZONTAL': '2.1 ROAD MARKINGS',
  '2.2 VERTICAL': '2.2 ROAD SIGNS',
  '3.3 Paneles direccionales': '3.3 Direction signs',
  '10.2 Señalización': '10.2 Signage',
  '5.1 Talud desmonte': '5.1 Cut slope',
  '5.2 Talud de terraplén': '5.2 Embankment slope',
  '5.3 Revestimientos': '5.3 Linings',
  '5.4 Sistemas de estabilización': '5.4 Stabilisation systems',
  '11.1 Barreras metálicas': '11.1 Metal barriers',
  '10.2 Pretiles': '10.2 Parapets',
  '10.3 Amortiguadores de impacto': '10.3 Crash cushions',
  '10.5 Sistemas de contención': '10.5 Restraint systems',
  '3.1 Hitos de arista': '3.1 Delineator posts',
  '3.2 Captafaros': '3.2 Road studs',
  '3.4 Balizas flexibles': '3.4 Flexible bollards',
  '2.2 VARIABLE': '2.2 VARIABLE',
  '10.4 Redes de protección': '10.4 Protection nets',
  'Instalaciones de ventilación': 'Ventilation systems',
  '1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS': '1.1 LANE · 1.1.1 ASPHALT PAVEMENT',
  '1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN': '1.1 LANE · 1.1.2 CONCRETE PAVEMENT',
  '1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS': '1.2 SHOULDER · 1.2.1 ASPHALT PAVEMENT',
  '1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN': '1.2 SHOULDER · 1.2.2 CONCRETE PAVEMENT',
  '1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS': '1.3 VERGE · 1.3.1 ASPHALT PAVEMENT',
  '1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN': '1.3 VERGE · 1.3.2 CONCRETE PAVEMENT',
};

const EU: Record<string, string> = {
  Deformaciones: 'Deformazioak',
  Roturas: 'Hausturak',
  Exudaciones: 'Exudazioak',
  'Deformaciones. Roderas': 'Deformazioak. Ildaskak',
  'Deformaciones. Hundimiento': 'Deformazioak. Hondoratzea',
  'Deformaciones. Cordón longitudinal': 'Deformazioak. Luzetarako kordoiak',
  'Deformaciones. Arrollamiento transversal': 'Deformazioak. Zeharkako bultzada',
  'Deformaciones. Firme ondulado': 'Deformazioak. Zoladura uhindua',
  'Deformaciones. Ondulación': 'Deformazioak. Uhindura',
  'Deformaciones. Blandón': 'Deformazioak. Eremu biguna',
  'Deformaciones. Huella': 'Deformazioak. Gurpil-arrastoa',
  'Deformaciones. Burbuja': 'Deformazioak. Burbuila',
  'Deformaciones. Protuberancia': 'Deformazioak. Koskorra',
  'Deformaciones. Escalonamientos': 'Deformazioak. Mailakatzea',
  'Deformaciones. Asientos': 'Deformazioak. Asentamendua',
  'Roturas. Grieta longitudinal': 'Hausturak. Luzetarako pitzadura',
  'Roturas. Bache': 'Hausturak. Zuloa',
  'Roturas. Grieta transversal': 'Hausturak. Zeharkako pitzadura',
  'Roturas. Grieta errática': 'Hausturak. Pitzadura irregularra',
  'Roturas. Grieta parabólica': 'Hausturak. Pitzadura parabolikoa',
  'Roturas. Cuarteo en malla': 'Hausturak. Krokodilo-azaleko pitzadurak',
  'Roturas. Grietas en las rodadas': 'Hausturak. Gurpil-arrastoetako pitzadurak',
  'Roturas. Grieta en el borde': 'Hausturak. Ertz-pitzadura',
  'Roturas. Grieta reflejada': 'Hausturak. Pitzadura islatua',
  'Roturas. Grieta curva': 'Hausturak. Pitzadura kurbatua',
  'Roturas. Fisuras finas': 'Hausturak. Arraildura finak',
  'Roturas. Descascarillado': 'Hausturak. Ezkatatzea',
  'Exudaciones. Flujo de ligante': 'Exudazioak. Aglutinatzaile-fluxua',
  'Exudaciones. Ascensión de finos': 'Exudazioak. Finen igoera',
  Fluencias: 'Fluentziak',
  Desgaste: 'Higadura',
  Desplazamiento: 'Desplazamendua',
  Desalineación: 'Lerrokatze falta',
  'Falta de reflectancia': 'Islagarritasun falta',
  'Fallo eléctrico': 'Akats elektrikoa',
  'Pantalla dañada': 'Pantaila hondatua',
  'Información incorrecta': 'Informazio okerra',
  Rotura: 'Haustura',
  Suciedad: 'Zikinkeria',
  Desprendimiento: 'Askatzea',
  'Deformación por impacto': 'Talkaren ondoriozko deformazioa',
  Erosión: 'Higadura',
  Colapso: 'Kolapsoa',
  'Rejilla rota': 'Sareta hautsita',
  Sedimentación: 'Sedimentazioa',
  'Tapa rota': 'Estalkia hautsita',
  'Infiltraciones/mancha humedad': 'Infiltrazioak/hezetasun-orbanak',
  'Colapso estructural': 'Egiturazko kolapsoa',
  Inundación: 'Uholdea',
  Inestabilidad: 'Ezegonkortasuna',
  Asentamientos: 'Asentamenduak',
  Deslizamientos: 'Lur-jausiak',
  'Rotura de malla': 'Sare-haustura',
  'Escollera desplazada': 'Harri-lubeta desplazatua',
  'Fallo de anclajes': 'Ainguraketa-akatsa',
  Corrosión: 'Korrosioa',
  Vegetación: 'Landaredia',
  Residuos: 'Hondakinak',
  Oxidación: 'Oxidazioa',
  'Lámpara rota': 'Lanpara hautsita',
  'Puerta rota': 'Atea hautsita',
  'Fallo de sensores': 'Sentsore-akatsa',
  Desconfiguración: 'Deskonfigurazioa',
  'iluminación insuficiente': 'Argiztapen eskasa',
  'Fallo de juntas': 'Juntura-akatsa',
  'Falta de estanqueidad': 'Estankotasun falta',
  'Fallo de ventiladores': 'Haizagailu-akatsa',
  'Fallo de señalización': 'Seinaleztapen-akatsa',
  'Fallo de Comunicación': 'Komunikazio-akatsa',
  'Fallo mecánico': 'Akats mekanikoa',
  'Fallo estructural': 'Egiturazko akatsa',
  '1 CALZADA': '1 GALTZADA',
  '6 APARTADEROS': '6 BAZTERGUNEAK',
  '9 TÚNELES': '9 TUNELAK',
  '10 VIAS DE SERVICIO': '10 ZERBITZU-BIDEAK',
  '2 SEÑALIZACIÓN': '2 SEINALEZTAPENA',
  '3 BALIZAMIENTO': '3 BALIZAMENDUA',
  '5 TALUDES': '5 EZPONDAK',
  '11 ELEMENTOS DE SEGURIDAD': '11 SEGURTASUN-ELEMENTUAK',
  '1.1 CARRIL': '1.1 ERREIA',
  '1.2 ARCÉN': '1.2 BAZTERBIDEA',
  '1.3 BERMA': '1.3 BERMA',
  '6.1 Zona de parada de emergencia': '6.1 Larrialdiko geldialdi-eremua',
  '6.2 Zona de inspección de vehículos': '6.2 Ibilgailuak ikuskatzeko eremua',
  '6.3 Zona de conservación': '6.3 Mantentze-eremua',
  'Calzada interior': 'Barneko galtzada',
  '10.1 Calzada': '10.1 Galtzada',
  '2.1 HORIZONTAL': '2.1 SEINALE HORIZONTALAK',
  '2.2 VERTICAL': '2.2 SEINALE BERTIKALAK',
  '3.3 Paneles direccionales': '3.3 Norabide-panelak',
  '10.2 Señalización': '10.2 Seinaleztapena',
  '5.1 Talud desmonte': '5.1 Ebaketa-ezponda',
  '5.2 Talud de terraplén': '5.2 Lubeta-ezponda',
  '5.3 Revestimientos': '5.3 Estaldurak',
  '5.4 Sistemas de estabilización': '5.4 Egonkortze-sistemak',
  '11.1 Barreras metálicas': '11.1 Metalezko hesiak',
  '10.2 Pretiles': '10.2 Parapetoak',
  '10.3 Amortiguadores de impacto': '10.3 Talkaren motelgailuak',
  '10.5 Sistemas de contención': '10.5 Euste-sistemak',
  '3.1 Hitos de arista': '3.1 Ertz-zutoinak',
  '3.2 Captafaros': '3.2 Errepideko islagailuak',
  '3.4 Balizas flexibles': '3.4 Baliza malguak',
  '2.2 VARIABLE': '2.2 ALDAKORRA',
  '10.4 Redes de protección': '10.4 Babes-sareak',
  'Instalaciones de ventilación': 'Aireztapen-instalazioak',
  '1.1 CARRIL · 1.1.1 PAQUETE FIRMES ASFALTICOS': '1.1 ERREIA · 1.1.1 ASFALTOZKO ZOLADURA',
  '1.1 CARRIL · 1.1.2 PAQUETE FIRMES HORMIGÓN': '1.1 ERREIA · 1.1.2 HORMIGOIZKO ZOLADURA',
  '1.2 ARCÉN · 1.2.1 PAQUETE FIRMES ASFALTICOS': '1.2 BAZTERBIDEA · 1.2.1 ASFALTOZKO ZOLADURA',
  '1.2 ARCÉN · 1.2.2 PAQUETE FIRMES HORMIGÓN': '1.2 BAZTERBIDEA · 1.2.2 HORMIGOIZKO ZOLADURA',
  '1.3 BERMA · 1.3.1 PAQUETE FIRMES ASFALTICOS': '1.3 BERMA · 1.3.1 ASFALTOZKO ZOLADURA',
  '1.3 BERMA · 1.3.2 PAQUETE FIRMES HORMIGÓN': '1.3 BERMA · 1.3.2 HORMIGOIZKO ZOLADURA',
};

export const translateRoadCatalog = (language: string, value?: string | null) => {
  if (!value) return value || '';
  const code = language.split('-')[0] as Language;
  if (code === 'en') return EN[value] || value;
  if (code === 'eu') return EU[value] || value;
  return value;
};
